if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      // The sticky add-to-cart bar: a stand-in for the product form that is
      // shown only while the real add-to-cart button is off screen, and hidden
      // again once the footer has scrolled up under it.
      //
      // The bar owns its own visibility. It watches the real button and the
      // footer directly with one IntersectionObserver, rather than relying on
      // zero-height sentinel elements scattered through the template, so
      // there is one place to look when it is on screen at the wrong time.
      //
      // It also publishes --sticky-bar-height on <html>: the distance from the
      // bottom of the viewport to the top of the bar while it is shown, 0px
      // otherwise. Anything else parked in the bottom corner (the chat
      // launcher) translates up by that amount so neither covers the other.
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        visible: false,
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        _anchorInView: false,
        _footerInView: false,
        _observer: null,
        _observerOffset: -1,
        _lift: 0,
        init() {
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });

          this.watchPage();
          this.publishHeight();
        },

        // --- visibility -----------------------------------------------------

        watchPage() {
          this.anchor = document.getElementById(`x-atc-button-${sectionId}`);
          this.footer = document.getElementById('section-footer');

          if (!this.anchor && !this.footer) {
            // Nothing to watch against: the bar is always on.
            this.visible = true;
            return;
          }
          this.observe(0);
        },

        // (Re)creates the observer with the bar's own height taken off the
        // bottom of the viewport, so "in view" means "visible above the bar",
        // not "peeking out from underneath it". The offset is 0 while the bar
        // is hidden and the bar's height while it is shown; the two never
        // disagree about the same scroll position, so it cannot flap.
        observe(offset) {
          offset = Math.max(0, Math.round(offset));
          if (offset === this._observerOffset) return;
          this._observerOffset = offset;

          if (this._observer) this._observer.disconnect();
          this._observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.target === this.anchor) this._anchorInView = entry.isIntersecting;
              if (entry.target === this.footer) this._footerInView = entry.isIntersecting;
            });
            this.visible = !this._anchorInView && !this._footerInView;
          }, {
            rootMargin: `0px 0px -${offset}px 0px`,
            threshold: 0
          });

          if (this.anchor) this._observer.observe(this.anchor);
          if (this.footer) this._observer.observe(this.footer);
        },

        // --- height ---------------------------------------------------------

        publishHeight() {
          const measure = () => {
            const rect = this.$el.getBoundingClientRect();
            const lift = this.visible && rect.height > 0
              ? Math.max(0, Math.round(window.innerHeight - rect.top))
              : 0;
            if (lift !== this._lift) {
              this._lift = lift;
              document.documentElement.style.setProperty('--sticky-bar-height', `${lift}px`);
            }
            if (this._observer) this.observe(lift);
          };

          if ('ResizeObserver' in window) {
            new ResizeObserver(measure).observe(this.$el);
          }
          window.addEventListener('resize', measure);
          // x-show flips display before the transition runs; measure once the
          // frame after so the rect is the shown (or hidden) one.
          this.$watch('visible', () => requestAnimationFrame(measure));
          this.$watch('openDetailOnMobile', () => setTimeout(measure, 350));
        },

        // --- variant sync with the main product form ------------------------

        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}
